export const billing_types = { monthly: "month", yearly: "year", daily: "day" };
export const Upgrade_Downgrade_types = {
  Subscription: "subscription",
  Users: "users",
  Companies: "companies",
};
